import type React from "react";

// Import icons from lucide-react
import { Facebook, Globe, Instagram, Linkedin, Twitter, Youtube } from "lucide-react";

// Helper function to return an icon for a given social media platform.
export const getSocialMediaIcon = (platform: string) => {
  switch (platform.toLowerCase()) {
    case "twitter":
      return <Twitter size={20}/>
    case "facebook":
      return <Facebook size={20}/>
    case "instagram":
      return <Instagram size={20}/>
    case "linkedin":
      return <Linkedin size={20}/>
    case "youtube":
      return <Youtube size={20}/>
    default:
      return <Globe size={20}/>
  }
}